<script>
import Vue from 'vue';
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from '@fullcalendar/rrule';
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import { INITIAL_EVENTS, createEventId } from "../calendario/event-utils";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import { http } from "@/helpers/easyindustriaapi/config";
import moment from "moment";
import "moment-timezone";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import Cookie from "js-cookie";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import calendarController from "@/controller/CalendarController";
import { createCkeditorUploadAdapterPlugin } from "@/helpers/ckeditor/ckeditorUploadAdapterPlugin";
import {
  getEvolutionDateViolationMessage,
  mergeEmpresaEvolutionPolicy,
} from "@/helpers/evolution-policy";
import { isRecurrenceAuthorized } from "@/helpers/attendance-authorization";
import {
  ROOM_NAME_MAX_CHARS,
  normalizeRoomName,
  validateRoomName,
} from "@/helpers/room-name";
import atendimentoController from "@/controller/AtendimentoController";
import callController from "@/controller/CallController";
import SchedulingRequestController from "@/controller/SchedulingRequestController";
import AtendimentosRealizados from "@/views/pages/relatorios/atendimentos/AtendimentosRealizados";
/** Resumo do atendimento no SweetAlert (event + recurrence). Não confundir com `profissionais/detail.vue` (ficha do profissional na listagem admin). */
import AgendaEventDetail from "./partials/calendar_edit.vue";
import SchedulingRequestForm from "./SchedulingRequestForm.vue";
import ResumoRepasseMe from "./ResumoRepasseMe.vue";

/** Fuso da clínica (PE): horários da API e metadados de chamada usam esta referência, não o offset do SO do profissional. */
const CLINIC_TIMEZONE = "America/Recife";

export default {
  props: {
    vet_responsible: { type: Array },
    vet_specialtys: { type: Array },
  },
  components: {
    FullCalendar,
    Multiselect,
    SchedulingRequestForm,
    ResumoRepasseMe,
    AgendaEventDetail,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      currentEmpresa: {},
      currentUser: {},
      currentHandle: null,
      vtitle:null,
      input_title_bol:false,
      specialtys: [],
      agenda: {},
      objeto_geral: null,
      modal_tittle_editar: null,
      profissionais: [],
      professional: null,
      select_prof: null,
      responsaveis: [],
      select_paciente: null,
      pacientes: [],
      paciente: null,
      // Guarda apenas o id para permitir restaurar o filtro antes da lista `pacientes` ser carregada.
      agendaFiltersPacienteId: null,
      modal_edit_del: false,
      vet_registros: [],
      vet_env_back: [],
      abr_div: false,
      tp_consulta: null,
      resp: null,
      select_inf: null,
      titulo: null,
      nome: null,
      showModal: false,
      calendarOptions: {
        plugins: [
          rrulePlugin,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
          bootstrapPlugin,
          listPlugin,
        ],
        locales: [ptBrLocale],
        // timeZone: 'America/Sao_Paulo',
        headerToolbar: {
          left: "prevYear,prev,next,nextYear today",
          center: "title",
          // mostra os botões de mês, semanas dias e listagem dia e mês
          right: "dayGridMonth,timeGridWeek,timeGridDay, listWeek,listDay",
        },
        initialView: "dayGridMonth",
        initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        initialDate: new Date(),
        eventColor: "#2490ff", // Info
        eventTextColor: "#FFFFFF", // Branco
        droppable: false,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventDrop: this.handleEventDrop,
        eventResize: this.handleEventResize,
        navLinks: true, // can click day/week names to navigate views
        eventDidMount: this.handleEventRender,
      },
      currentEvents: [],
      toogleIntructions: false,
      params: {
        professionals: null,
        pacients: null,
        date_ini: null,
        date_fim: null
      },
      contextMenu: {
        show: false,
        x: 0,
        y: 0,
        event: null
      },
      showRescheduleModal: false,
      rescheduleForm: {
        atendimento_id: null,
        empresa_id: null,
        old_date_end: null,
        new_date_start: null,
        new_time_start: null,
        new_time_end: null,
      },
      showSchedulingRequestModal: false,
      selectedEventForReschedule: null,
      showReplacementModal: false,
      replacementForm: {
        agenda_id: null,
        original_date: null,
        original_start_time: null,
        original_end_time: null,
        new_date: null,
        new_time_start: null,
        new_time_end: null,
      },
      showResumoRepasseModal: false,
      // Modal de edição do "Parecer" (evolução) do evento
      showParecerModal: false,
      parecerEvent: null,
      parecerEventFormatted: null,
      parecerRecurrence: null,
      parecerIsCurrentMonth: true,
      parecerIsTodayOrFuture: false,
      parecerValue: '',
      parecerMaxChars: 1000,

      // Gravação de áudio -> IA (Whisper + Chat) para gerar evolução
      isRecording: false,
      isProcessing: false,
      mediaRecorder: null,
      audioChunks: [],
      recordingStartedAt: null,
      minRecordingMs: 1500,

      // VU meter em tempo real durante a gravação
      audioContext: null,
      audioAnalyser: null,
      audioAnalyserInterval: null,
      audioLevel: 0,
      audioLevelMax: 0,
      editor: ClassicEditor,

      // Listener websocket (Pusher) para atualizações em tempo real
      pusherChannel: null,
      pusherChannelName: null,

      // Debounce para evitar múltiplos refreshes seguidos via websocket
      lastAuthorizedUpdateTs: 0,
      authorizedUpdateInFlight: false,

      // Ponte de estado: quando o profissional marca "Estou ciente"
      // a UI deve refletir imediatamente (sem depender do polling).
      onProfessionalAwareUpdated: null,
    };
  },
  created() {
    this.currentUser    = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
    this.specialtys     = this.vet_specialtys
    this.atendimentoController = new atendimentoController(this.currentUser, this.currentEmpresa)
    this.calendarController    = new calendarController(this.currentUser, this.currentEmpresa)
    this.callController        = new callController(this.currentUser, this.currentEmpresa)
    this.schedulingRequestController = new SchedulingRequestController(this.currentUser, this.currentEmpresa)
  },
  mounted() {
    // Restaurar filtros salvos antes de carregar a agenda
    this.loadAgendaFiltersFromStorage()
    this.checkRoom()
    // Usar arrow functions ou bind para manter o contexto
    this.hideContextMenuBound = this.hideContextMenu.bind(this)
    this.preventDefaultContextMenuBound = this.preventDefaultContextMenu.bind(this)
    
    // Fechar menu ao clicar fora
    document.addEventListener('click', this.hideContextMenuBound)
    // Prevenir menu padrão do navegador
    document.addEventListener('contextmenu', this.preventDefaultContextMenuBound)

    // Notificações em tempo real (ex.: recepção autorizou um atendimento)
    this.setupAuthorizedAttendanceWebSocketListener()
    // O header (horizontal-topbar / topbar) é quem recebe Pusher/polling de forma confiável;
    // escutamos o mesmo payload via $root para atualizar o modal "Parecer" na agenda.
    this._onEasysaudeUserNotification = (payload) => {
      this.handlePusherAuthorizedAttendance(payload)
    }
    this.$root.$on('easysaude:user-notification', this._onEasysaudeUserNotification)

    // Atualiza imediatamente o estado "professional_aware" quando o botão
    // do sino for clicado (sem esperar o polling).
    this.onProfessionalAwareUpdated = (payload) => {
      if (!payload) return
      const recurrenceId =
        payload.recurrence_id != null ? Number(payload.recurrence_id) : null
      if (!Number.isFinite(recurrenceId) || recurrenceId <= 0) return

      // Modal aberto
      if (this.parecerRecurrence && Number(this.parecerRecurrence.id) === recurrenceId) {
        this.$set(this.parecerRecurrence, 'professional_aware', true)
      }

      // Fonte de verdade (lista) caso já esteja carregada
      if (Array.isArray(this.listAgendas)) {
        this.listAgendas.forEach((agenda) => {
          const recs = agenda && Array.isArray(agenda.recurrences) ? agenda.recurrences : []
          recs.forEach((rec) => {
            if (rec && Number(rec.id) === recurrenceId) {
              this.$set(rec, 'professional_aware', true)
            }
          })
        })
      }

      // Segurança extra para objetos do FullCalendar
      if (Array.isArray(this.calendarOptions?.events)) {
        this.calendarOptions.events.forEach((fcEvent) => {
          const recs =
            fcEvent && fcEvent.extendedProps && Array.isArray(fcEvent.extendedProps.recurrences)
              ? fcEvent.extendedProps.recurrences
              : []
          recs.forEach((rec) => {
            if (rec && Number(rec.id) === recurrenceId) {
              this.$set(rec, 'professional_aware', true)
            }
          })
        })
      }
    }
    this.$root.$on('easysaude:professional-aware-updated', this.onProfessionalAwareUpdated)
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("empresa_id", this.currentEmpresa.id);

      if (this.paciente) {
        params.append("pacient_id", this.paciente.id);
      }

      return params;
    },
    dateAgrement() {
      const date = new Date();
      date.setMinutes(date.getMinutes() + 40);
      return date;
    },
    contextMenuStyle() {
      return {
        position: 'fixed',
        left: this.contextMenu.x + 'px',
        top: this.contextMenu.y + 'px',
        zIndex: 9999
      }
    },
    parecerTextLength() {
      // Conta apenas texto (remove tags HTML do CKEditor)
      return String(this.parecerValue || "").replace(/<[^>]*>/g, "").length
    },
    parecerRemaining() {
      return this.parecerMaxChars - this.parecerTextLength
    },
    /** True quando a recorrência permite registrar/editar evolução (autorização na recepção). */
    parecerEvolutionAuthorized() {
      return this.isRecurrenceAuthorizedForEvolution(this.parecerRecurrence)
    },

    /** True quando a recorrência já foi marcada como "ciente" pelo profissional (professional_aware). */
    parecerProfessionalAware() {
      const aware = this.parecerRecurrence ? this.parecerRecurrence.professional_aware : null
      return aware === true || aware === 1 || aware === "1"
    },
    parecerCanCallPatient() {
      return this.parecerIsCurrentMonth && this.parecerIsTodayOrFuture && this.parecerEvolutionAuthorized
    },
    /**
     * Exibe o botão Gravar quando a data permite edição e a recorrência está autorizada.
     * Não depende de professional_aware — o back-end aceita atualizar o parecer independentemente.
     */
    parecerCanSaveEvolution() {
      return this.parecerEvolutionDateAllowed && this.parecerEvolutionAuthorized
    },
    audioLevelClass() {
      if (this.audioLevel >= 25) return "vu-meter-bar--good"
      if (this.audioLevel >= 8) return "vu-meter-bar--low"
      return "vu-meter-bar--mute"
    },
    audioLevelWarning() {
      if (!this.isRecording) return ""
      // Só mostra aviso depois de ~1.5s de gravação e se o pico máximo continuou baixo
      const recordingMs = this.recordingStartedAt ? Date.now() - this.recordingStartedAt : 0
      if (recordingMs < 1500) return ""
      if (this.audioLevelMax < 8) return "Microfone muito baixo — verifique o mic!"
      if (this.audioLevelMax < 20) return "Volume baixo — fale mais próximo."
      return ""
    },
    parecerEditorConfig() {
      const token = Cookie.get('_easyindustria_token')
      const headers = token
        ? {
            Authorization: `Bearer ${token}`,
            'X-Empresa-Id': String(this.currentEmpresa?.id || 0),
          }
        : { 'X-Empresa-Id': String(this.currentEmpresa?.id || 0) }

      return {
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'imageUpload',
          'undo',
          'redo',
        ],
        image: {
          toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side'],
        },
        extraPlugins: [
          createCkeditorUploadAdapterPlugin({
            uploadUrl: `${process.env.VUE_APP_BASEURI}/api/ckeditor/upload?empresa_id=${this.currentEmpresa?.id || 0}`,
            headers,
          }),
        ],
      }
    },
    /** Alinhado a `Empresa::evolutionRegistrationDateViolation` (fuso PE). */
    parecerEvolutionDateViolationMessage() {
      if (!this.parecerEventFormatted || !this.parecerEventFormatted.start) {
        return null
      }
      return getEvolutionDateViolationMessage({
        start: this.parecerEventFormatted.start,
        empresa: this.currentEmpresa,
        timezone: CLINIC_TIMEZONE,
      })
    },
    parecerEvolutionDateAllowed() {
      return this.parecerEvolutionDateViolationMessage === null
    },
    /** Configuração do CKEditor sem toolbar e sem upload para exibição somente leitura. */
    readonlyEditorConfig() {
      return {
        toolbar: [],
        removePlugins: ['imageUpload', 'link', 'BlockQuote', 'Table', 'MediaEmbed'],
        language: 'pt-br',
      }
    },
  },
  beforeDestroy() {
    if (this._onEasysaudeUserNotification) {
      this.$root.$off('easysaude:user-notification', this._onEasysaudeUserNotification)
      this._onEasysaudeUserNotification = null
    }

    if (this.onProfessionalAwareUpdated) {
      this.$root.$off('easysaude:professional-aware-updated', this.onProfessionalAwareUpdated)
      this.onProfessionalAwareUpdated = null
    }

    document.removeEventListener('click', this.hideContextMenu)
    document.removeEventListener('contextmenu', this.preventDefaultContextMenu)

    // Limpar listener websocket (Pusher) se configurado
    try {
      if (this.pusherChannel) {
        this.pusherChannel.unbind('nova.notificacao', this.onPusherNotificationReceived)
        // Também remove binds padrão/antigos caso o Pusher remova listeners por canal
        if (this.pusherChannelName) {
          window.pusher && window.pusher.unsubscribe(this.pusherChannelName)
        }
      }
    } catch (_) {
      // noop
    }
  },
  methods: {
    normalizeTimeToSeconds(timeValue) {
      const raw = String(timeValue == null ? '' : timeValue).trim()
      if (!raw) return '00:00:00'
      if (raw.length === 5) return `${raw}:00`
      const parsed = moment(raw, ['HH:mm:ss', 'HH:mm', 'H:mm:ss', 'H:mm'], true)
      return parsed.isValid() ? parsed.format('HH:mm:ss') : '00:00:00'
    },

    setupAuthorizedAttendanceWebSocketListener() {
      if (this.pusherChannel) return
      if (!window.pusher || !this.currentUser || !this.currentUser.id) return

      this.pusherChannelName = `private-App.Models.User.${this.currentUser.id}`

      const subscribeAndBind = () => {
        try {
          this.pusherChannel = window.pusher.subscribe(this.pusherChannelName)
          if (!this.onPusherNotificationReceived) {
            this.onPusherNotificationReceived = (data) => this.handlePusherAuthorizedAttendance(data)
          }
          this.pusherChannel.bind('nova.notificacao', this.onPusherNotificationReceived)
        } catch (e) {
          console.error('Erro ao configurar listener websocket de autorização:', e)
        }
      }

      try {
        if (window.pusher.connection.state === 'connected') {
          subscribeAndBind()
        } else {
          const onConnected = () => {
            window.pusher.connection.unbind('connected', onConnected)
            subscribeAndBind()
          }
          window.pusher.connection.bind('connected', onConnected)
        }
      } catch (e) {
        console.error('Erro ao configurar listener websocket de autorização:', e)
      }
    },

    handlePusherAuthorizedAttendance(data) {
      // Formato (do topbar / horizontal-topbar / $root): { titulo, mensagem, recurrence_id, ... }
      // ou envelope { data: [ {...} ] } (alguns clientes).
      if (!data) return

      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.handlePusherAuthorizedAttendance(item)
        })
        return
      }
      if (data?.data && Array.isArray(data.data)) {
        data.data.forEach((item) => {
          this.handlePusherAuthorizedAttendance(item)
        })
        return
      }

      const titulo = String(data.titulo || data.title || '').trim().toLowerCase()
      const tituloClean = titulo.replace(/[.!?]+$/g, '').trim()
      const tituloNormalized = tituloClean
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const recurrenceId =
        data.recurrence_id != null ? data.recurrence_id : (data.recurrenceId != null ? data.recurrenceId : null)

      // Notificações do profissional que possuem `recurrence_id` devem seguir
      // o mesmo protocolo: atualizar a recorrência e o modal de "Parecer".
      // Ex.: "Atendimento autorizado" e "Reposição autorizada".
      const isAuthorizedEvent =
        tituloNormalized === 'atendimento autorizado' ||
        tituloNormalized.startsWith('atendimento autorizado ') ||
        tituloNormalized === 'reposicao autorizada' ||
        tituloNormalized.startsWith('reposicao autorizada ')

      if (!isAuthorizedEvent) return
      if (recurrenceId == null || recurrenceId === '') return

      this.applyAuthorizedAttendanceToRecurrence(recurrenceId)

      const rid = Number(recurrenceId)
      if (
        Number.isFinite(rid) &&
        this.parecerRecurrence &&
        Number(this.parecerRecurrence.id) === rid &&
        data.professional_aware != null
      ) {
        this.$set(this.parecerRecurrence, 'professional_aware', !!data.professional_aware)
      }
    },

    // ---- Persistência de filtros (somente esta tela) ----
    agendaFiltersStorageKey() {
      const userId = this.currentUser && this.currentUser.id
      const empresaId = this.currentEmpresa && this.currentEmpresa.id
      // Chave única para não misturar com outras telas
      return `easysaude:professional_calendar:filters:v1:u${userId || 'na'}:e${empresaId || 'na'}`
    },

    loadAgendaFiltersFromStorage() {
      try {
        const raw = localStorage.getItem(this.agendaFiltersStorageKey())
        if (!raw) return
        const parsed = JSON.parse(raw)
        this.paciente = parsed.pacienteId ? { id: parsed.pacienteId } : null
        this.agendaFiltersPacienteId = parsed.pacienteId || null
        this.calendarOptions.weekends = parsed.weekends != null ? !!parsed.weekends : this.calendarOptions.weekends
      } catch (_) {
        // noop: não impede a navegação
      }
    },

    saveAgendaFiltersToStorage() {
      try {
        const payload = {
          pacienteId: this.paciente && this.paciente.id ? this.paciente.id : null,
          weekends: this.calendarOptions.weekends,
        }
        localStorage.setItem(this.agendaFiltersStorageKey(), JSON.stringify(payload))
      } catch (_) {
        // noop
      }
    },

    clearAgendaFilters() {
      this.paciente = null
      this.agendaFiltersPacienteId = null
      // Reset padrão: mostrar fins de semana
      this.calendarOptions.weekends = true
      try {
        localStorage.removeItem(this.agendaFiltersStorageKey())
      } catch (_) {
        // noop
      }
      this.fetchList()
    },

    applyAgendaFiltersAndFetch() {
      // Só persiste quando o usuário efetivamente clicar em "Filtrar"
      this.saveAgendaFiltersToStorage()
      this.fetchList()
    },

    applyAuthorizedAttendanceToRecurrence(recurrenceId) {
      const targetId = Number(recurrenceId)
      if (!Number.isFinite(targetId) || targetId <= 0) return

      let updated = false

      // Atualiza a fonte de verdade que veio do backend (this.listAgendas)
      if (Array.isArray(this.listAgendas)) {
        this.listAgendas.forEach((agenda) => {
          const recs = agenda && Array.isArray(agenda.recurrences) ? agenda.recurrences : []
          recs.forEach((rec) => {
            if (rec && Number(rec.id) === targetId) {
              // Garantir reatividade
              this.$set(rec, 'is_authorized', true)
              updated = true
            }
          })
        })
      }

      // Atualiza também objetos já montados para o FullCalendar (segurança extra)
      if (Array.isArray(this.calendarOptions?.events)) {
        this.calendarOptions.events.forEach((fcEvent) => {
          const recs = fcEvent && fcEvent.extendedProps && Array.isArray(fcEvent.extendedProps.recurrences)
            ? fcEvent.extendedProps.recurrences
            : []
          recs.forEach((rec) => {
            if (rec && Number(rec.id) === targetId) {
              this.$set(rec, 'is_authorized', true)
              updated = true
            }
          })
        })
      }

      // Se o modal estiver aberto, garante que o computed do botão reaja
      if (this.parecerRecurrence && Number(this.parecerRecurrence.id) === targetId) {
        this.$set(this.parecerRecurrence, 'is_authorized', true)
        updated = true
      }

      // Caso o modal tenha sido aberto antes da recorrência ser criada/atualizada
      // (ex.: item virtual sem `id` no momento do clique), `parecerRecurrence` pode
      // estar null ou sem `id` correspondente. Nesse caso, buscamos a recorrência
      // atualizada dentro do evento atualmente selecionado.
      if (this.parecerEvent && this.parecerEvent.id != null && Array.isArray(this.calendarOptions?.events)) {
        const parecerAgendaId = Number(this.parecerEvent.id)
        const fcEvent = this.calendarOptions.events.find((e) => e && Number(e.id) === parecerAgendaId)
        const recs =
          fcEvent && fcEvent.extendedProps && Array.isArray(fcEvent.extendedProps.recurrences)
            ? fcEvent.extendedProps.recurrences
            : []

        // 1) Tenta casar primeiro por id da tabela `recurrences` (quando existe).
        let match = recs.find((rec) => rec && rec.id != null && Number(rec.id) === targetId) || null

        // 2) Fallback: quando a recorrência era "virtual" (sem id) antes da autorização,
        // o `recurrenceId` recebido pode não bater com o objeto que o modal está usando.
        // Então casamos pelo mesmo critério do `viewEvent()`: data + start_time/end_time.
        if (!match && this.parecerEventFormatted) {
          const eventDateStr = this.extractEventDatePart(this.parecerEvent)
          const agendaSt = this.timeToHmLiteral(this.parecerEventFormatted.start_time)
          const agendaEt = this.timeToHmLiteral(this.parecerEventFormatted.end_time)

          match = recs.find((rec) => {
            const itemDate = rec && rec.start ? String(rec.start).split('T')[0].substring(0, 10) : ''
            const itemSt = this.timeToHmLiteral(rec && rec.start_time)
            const itemEt = this.timeToHmLiteral(rec && rec.end_time)
            return itemDate === eventDateStr && itemSt === agendaSt && itemEt === agendaEt
          }) || null
        }

        if (match) {
          this.parecerRecurrence = match
          this.$set(this.parecerRecurrence, 'is_authorized', true)
          updated = true
        }
      }

      // Regras do modal: busca global por `recurrence.id` (mais robusto).
      // Mesmo que o modal esteja “apontando” para um objeto stale ou
      // o evento/critério de data+hora não consiga casar, se existir
      // a recurrence id=targetId dentro do FullCalendar, atualizamos o modal.
      if (this.showParecerModal && Array.isArray(this.calendarOptions?.events)) {
        let globalMatch = null
        this.calendarOptions.events.forEach((fcEvent) => {
          if (globalMatch) return
          const recs =
            fcEvent && fcEvent.extendedProps && Array.isArray(fcEvent.extendedProps.recurrences)
              ? fcEvent.extendedProps.recurrences
              : []
          globalMatch = recs.find((rec) => rec && rec.id != null && Number(rec.id) === targetId) || null
        })

        if (globalMatch) {
          this.parecerRecurrence = globalMatch
          this.$set(this.parecerRecurrence, 'is_authorized', true)
          this.parecerValue = this.parecerRecurrence.desc || ''
          updated = true
        }
      }

      // Força refresh leve do FullCalendar (não deve ser necessário, mas reduz risco de render stale)
      if (updated) {
        this.calendarOptions.events = Array.isArray(this.calendarOptions.events)
          ? [...this.calendarOptions.events]
          : this.calendarOptions.events
        return
      }

      // Fallback: FullCalendar pode ter clonado referências.
      // Recarrega a agenda para garantir que a recorrência virá com is_authorized=true.
      const now = Date.now()
      if (this.authorizedUpdateInFlight) return
      if (now - this.lastAuthorizedUpdateTs < 2000) return
      this.lastAuthorizedUpdateTs = now
      this.authorizedUpdateInFlight = true
      this.fetchList()
        .then(() => {
          // Se o modal de Parecer estiver aberto, precisamos re-sincronizar
          // de verdade o estado do modal, porque `fetchList()` recria eventos
          // e o modal pode continuar apontando para referências antigas.
          if (!this.showParecerModal) return
          if (!this.parecerEvent || this.parecerEvent.id == null) return

          const fcEvent =
            this.calendarOptions?.events?.find((e) => e && Number(e.id) === Number(this.parecerEvent.id)) || null
          if (!fcEvent) return

          // Garantir que `viewEvent()` use o objeto agenda atual (this.objeto_geral).
          this.objeto_geral = Array.isArray(this.listAgendas)
            ? this.listAgendas.find((e) => e && Number(e.id) === Number(fcEvent.id)) || this.objeto_geral
            : this.objeto_geral

          // Reaplicar a abertura do modal para recalcular `parecerRecurrence`
          // e os computed que alimentam os badges/botões.
          this.viewEvent(fcEvent)
        })
        .catch(() => {})
        .finally(() => {
          this.authorizedUpdateInFlight = false
        })
    },
    extractEventDatePart(fcEvent) {
      const startStr = String(fcEvent && fcEvent.startStr ? fcEvent.startStr : '').trim()
      if (startStr.length >= 10) {
        return startStr.substring(0, 10)
      }
      const fallback = moment(fcEvent && fcEvent.start ? fcEvent.start : null)
      return fallback.isValid() ? fallback.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
    },
    /** Data civil YYYY-MM-DD a partir do campo `start` da agenda (string ISO naive ou datetime API), sem depender de UTC. */
    extractCalendarDateFromAgendaStart(rawStart) {
      if (rawStart == null || rawStart === '') {
        return moment.tz(CLINIC_TIMEZONE).format('YYYY-MM-DD')
      }
      const s = String(rawStart).trim()
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
        return s.substring(0, 10)
      }
      const m = moment(s)
      return m.isValid() ? m.format('YYYY-MM-DD') : moment.tz(CLINIC_TIMEZONE).format('YYYY-MM-DD')
    },
    /**
     * Alinha `start`/`end` da agenda ao relógio de parede da clínica (API): YYYY-MM-DD + start_time/end_time.
     * Não usa fuso do navegador para montar o horário exibido no FullCalendar.
     */
    applyNaiveIsoToAgendas(agendas) {
      if (!Array.isArray(agendas)) return
      agendas.forEach((row) => {
        const day = this.extractCalendarDateFromAgendaStart(row.start)
        const st = this.normalizeTimeToSeconds(row.start_time)
        const et = this.normalizeTimeToSeconds(row.end_time)
        row.start = `${day}T${st}`
        row.end = `${day}T${et}`
      })
    },
    /** HH:mm a partir de start_time/end_time da API (fonte da verdade). */
    timeToHmLiteral(timeValue) {
      return moment(this.normalizeTimeToSeconds(timeValue), 'HH:mm:ss', true).format('HH:mm')
    },
    extractRecurrenceDatePart(recurrence) {
      if (!recurrence || !recurrence.start) return ''
      return String(recurrence.start).split('T')[0].substring(0, 10)
    },
    extractRecurrenceEndDatePart(recurrence) {
      if (!recurrence) return ''
      if (recurrence.end) return String(recurrence.end).split('T')[0].substring(0, 10)
      return this.extractRecurrenceDatePart(recurrence)
    },
    resolveEventRecurrence(event, agenda = null) {
      const recurrences = event?.extendedProps?.recurrences || []
      if (!Array.isArray(recurrences) || !recurrences.length) return null

      const eventDate = this.extractEventDatePart(event)
      const eventEndDate =
        String(event?.endStr || '').trim().length >= 10
          ? String(event.endStr).substring(0, 10)
          : eventDate
      const agendaRef = agenda || this.listAgendas.find((item) => Number(item.id) === Number(event.id)) || {}
      const startTime = this.normalizeTimeToSeconds(agendaRef.start_time || event?.extendedProps?.startTime)
      const endTime = this.normalizeTimeToSeconds(agendaRef.end_time || event?.extendedProps?.endTime)
      const eventAttendanceId = Number(event?.extendedProps?.atendimento_id || 0)
      const eventRecurrenceId = Number(event?.extendedProps?.recurrence_id || event?.extendedProps?.recurrenceId || 0)

      if (eventRecurrenceId > 0) {
        const byRecurrenceId = recurrences.find((rec) => Number(rec?.id || 0) === eventRecurrenceId)
        if (byRecurrenceId) return byRecurrenceId
      }

      const strictMatches = recurrences.filter((rec) => {
        const recurrenceStartDate = this.extractRecurrenceDatePart(rec)
        const recurrenceEndDate = this.extractRecurrenceEndDatePart(rec)
        const recStart = this.normalizeTimeToSeconds(rec?.start_time)
        const recEnd = this.normalizeTimeToSeconds(rec?.end_time)

        return (
          recurrenceStartDate === eventDate
          && recurrenceEndDate === eventEndDate
          && recStart === startTime
          && recEnd === endTime
        )
      })

      if (!strictMatches.length) {
        const sameDateMatches = recurrences.filter((rec) => this.extractRecurrenceDatePart(rec) === eventDate)
        const authorizedSameDateMatches = sameDateMatches.filter((rec) => this.isRecurrenceAuthorizedForEvolution(rec))

        if (authorizedSameDateMatches.length === 1) {
          return authorizedSameDateMatches[0]
        }

        if (sameDateMatches.length === 1) {
          return sameDateMatches[0]
        }

        return null
      }

      if (eventAttendanceId > 0) {
        const byAttendanceId = strictMatches.find((rec) => Number(rec?.atendimento_id || 0) === eventAttendanceId)
        if (byAttendanceId) return byAttendanceId
      }

      return strictMatches[0] || null
    },
    /**
     * Texto de horário exibido no slot do FullCalendar (timeGrid/dayGrid/popover).
     * Não usa `arg.timeText` (derivado de Date interno → pode sofrer fuso); usa extendedProps da API.
     */
    formatFcEventContentTime(arg) {
      const ev = arg && arg.event ? arg.event : null
      if (!ev) return (arg && arg.timeText) || ''
      const st = ev.extendedProps && ev.extendedProps.startTime
      const et = ev.extendedProps && ev.extendedProps.endTime
      if (st != null && String(st).trim() !== '') {
        const s = moment(this.normalizeTimeToSeconds(st), 'HH:mm:ss', true).format('HH:mm')
        const e =
          et != null && String(et).trim() !== ''
            ? moment(this.normalizeTimeToSeconds(et), 'HH:mm:ss', true).format('HH:mm')
            : ''
        if (e && e !== s) {
          return `${s} - ${e}`
        }
        return s
      }
      return (arg && arg.timeText) || ''
    },
    async fetchList() {
      let listObjects = await this.calendarController.getProfessionalCalendar(this.axiosParams)
      if (listObjects && Object.prototype.hasOwnProperty.call(listObjects, 'bloquear_evolucao_meses_retroativos')) {
        this.currentEmpresa = mergeEmpresaEvolutionPolicy(this.currentEmpresa, listObjects)
        try {
          localStorage.setItem('currentEmpresa', JSON.stringify(this.currentEmpresa))
        } catch (e) {
          /* ignore quota / private mode */
        }
      }
      const agendas = listObjects.agendas || []
      this.applyNaiveIsoToAgendas(agendas)
      this.calendarOptions.events = this.calendarController.eventsProfessionalResource(agendas)
      this.listAgendas   = agendas
      this.vet_registros = agendas
      this.pacientes     = listObjects.pacients
      // Se havia filtro restaurado de storage, substitui {id} por objeto real (para o multiselect e reatividade).
      if (this.agendaFiltersPacienteId) {
        const found = (this.pacientes || []).find((p) => Number(p.id) === Number(this.agendaFiltersPacienteId))
        if (found) this.paciente = found
      }
      this.responsaveis  = listObjects.responsibles
      this.abr_div = false
      setTimeout(() => {
        this.abr_div = true
        return this.calendarOptions.events
      }, 100)
    },
    addContextMenuToEvent(element, event) {
      element.addEventListener('contextmenu', (e) => {
        e.preventDefault()
        this.showContextMenu(e, event)
      })
    },
    showContextMenu(e, event) {
      this.contextMenu.show = true
      this.contextMenu.x = e.clientX
      this.contextMenu.y = e.clientY
      this.contextMenu.event = event
    },
    hideContextMenu() {
      this.contextMenu.show = false
      this.contextMenu.event = null
    },
    preventDefaultContextMenu(e) {
      // Prevenir menu padrão apenas em eventos do calendário
      if (e.target.closest('.fc-event')) {
        e.preventDefault()
      }
    },
    handleEventRender(info) {
      this.addContextMenuToEvent(info.el, info.event)
      this.agenda = this.listAgendas.find((e) => e.id == info.event.id)
      info.event.agenda = this.agenda;
      const recurrenceStart = this.normalizeTimeToSeconds(this.agenda && this.agenda.start_time)
      const recurrenceEnd = this.normalizeTimeToSeconds(this.agenda && this.agenda.end_time)
      const element = info.el.querySelector('.fc-list-event-time')

      if (element) {
        const formattedStart = moment(recurrenceStart, 'HH:mm:ss', true).format('HH:mm')
        const formattedEnd = moment(recurrenceEnd, 'HH:mm:ss', true).format('HH:mm')
        element.innerHTML = `${formattedStart} às ${formattedEnd}`
      }

      this.aplicarCorSeTemEvolucao(info)
    },
    aplicarCorSeTemEvolucao(info) {
      const agenda = this.listAgendas.find((e) => Number(e.id) === Number(info.event.id)) || {}
      const matchingRecurrence = this.resolveEventRecurrence(info.event, agenda)
      const descPreenchido = matchingRecurrence && matchingRecurrence.desc != null && String(matchingRecurrence.desc).trim() !== ''

      if (descPreenchido) {
        info.el.style.background = 'linear-gradient(135deg, #dff4c8 0%, rgba(210,241,232,.85) 100%)';
        info.el.style.borderColor = '#0f6149';
        info.el.style.color = '#0f6149';
        if (matchingRecurrence.desc && String(matchingRecurrence.desc).trim()) {
          info.el.title = matchingRecurrence.desc;
        }
      }
    },
    alter_title(event){
      console.log(event);
      this.input_title_bol = (this.vtitle);
    },
    seleciona_specialty(event) {
      console.log(event);
    },
    async doPut(event) {
      const startYmd = typeof event.start === 'string' && /^\d{4}-\d{2}-\d{2}/.test(event.start)
        ? String(event.start).substring(0, 10)
        : this.extractEventDatePart({ start: event.start, startStr: event.startStr })
      const endYmd = typeof event.end === 'string' && /^\d{4}-\d{2}-\d{2}/.test(event.end)
        ? String(event.end).substring(0, 10)
        : startYmd
      // Objeto calendario (recurrence_id: usar o criado na autorização, evita duplicar na tabela recurrences)
      let calendar = {
        id: event.id,
        desc: event.desc,
        empresa_id: this.currentEmpresa.id,
        end: endYmd,
        end_time: event.end_time,
        professional_id: event.professional_id,
        specialty_id: event.specialty_id,
        pacient_id: event.pacient_id,
        start: startYmd,
        start_time: event.start_time,
        title: event.title,
      };
      if (event.recurrence_id != null) {
        calendar.recurrence_id = event.recurrence_id;
      }

      // Exibe o SweetAlert com loader
      Swal.fire({
        title: "Aguarde...",
        text: "Estamos processando sua solicitação.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        },
      });

      const promisse = http.put(`/agenda/${calendar.id}/updateCalendarRecurrence?empresa_id=${this.currentEmpresa.id}`,calendar);

      return promisse
        .then(() => {
          Swal.close(); // Fecha o loader
          this.makeToast("success", "Atendimento reagendado com sucesso!");
          this.fetchList();
        })
        .catch((error) => {
          console.log(error);
          Swal.close(); // Fecha o loader

          if (error.response && error.response.status === 403) {
            const data = error.response.data || {}
            const msg =
              data.message || data.error || "Evolução não autorizada. Solicite a autorização do atendimento na recepção."
            Swal.fire({
              icon: "warning",
              title: "Evolução não autorizada",
              text: msg,
            })
            return
          }

          if (error.response && error.response.status === 422) {
            const data = error.response.data || {}
            const fromErrors = data.errors && (data.errors.start && data.errors.start[0])
            const msg =
              fromErrors
              || data.message
              || (typeof data === 'string' ? data : null)
              || "Não foi possível salvar a evolução. Verifique a data e tente novamente."
            Swal.fire({
              icon: "warning",
              title: "Validação",
              text: msg,
            })
            return
          }

          // Tratamento de erro 500
          if (error.response && error.response.status === 406) {
            // Exibe mensagem de erro específica para o código 406
            let timerInterval;
            Swal.fire({
              icon: "error",
              title: "Erro de Preenchimento!",
              text: error.response.data.error,
              timer: 5000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const timer = Swal.getPopup().querySelector("b");
                timerInterval = setInterval(() => {
                  timer.textContent = `${Swal.getTimerLeft()}`;
                }, 100);
              },
              willClose: () => {
                clearInterval(timerInterval);
                this.viewEvent(this.currentHandle.event);
              },
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                console.log("I was closed by the timer");
              }
            });
          } else if (error.response && error.response.status === 500) {
            Swal.fire({
              icon: "error",
              title: "ERRO",
              html: `Erro no servidor ao processar informação: <BR /><span class="text-danger">${error.message}</span>`,
              willClose: () => {
                this.viewEvent(this.currentHandle.event);
              }
            });
          } else {
            // Tratamento genérico de outros erros
            Swal.fire({
              icon: "error",
              title: "Erro!",
              html: `Houve um erro ao processar sua requisição! <BR /><span class="text-danger">${error.response.data}</span>`,
              willClose: () => {
                this.viewEvent(this.currentHandle.event);
              }
            });
          }
        });
    },
    seleciona_paciente(objeto) {
      let pacient = this.pacientes.find((p) => p.id == objeto.target.value);
      this.agenda.titulo = pacient.nome;
    },
    seleciona_prof(objeto) {
      let prof = this.profissionais.find((p) => p.id == objeto.target.value);
      this.agenda.titulo = `${this.agenda.titulo} | ${prof.name}`;
    },
    fechar_modal_edit() {
      this.modal_edit_del = false;
    },
    // evento para redimensionar o agendas ja existentes
    handleEventResize(eventResizeInfo) {
      // Lógica para atualizar a duração de um evento ao redimensioná-lo
      eventResizeInfo.revert();
    },
    handleDateClick(arg) {
      console.log(arg);
    },
    handleEventDrop(info) {
      info.revert();
    },
    // evento para editar e exluir
    handleEventClick(clickInfo) {
      console.log(clickInfo.event);
      // pesquisa o evento na lista de calendários por id
      this.currentHandle = clickInfo;
      this.objeto_geral = this.listAgendas.find((e) => e.id == clickInfo.event.id);
      this.viewEvent(clickInfo.event);
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    handleDateSelect(selectInfo) {
      console.log(selectInfo);
    },
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
      this.saveAgendaFiltersToStorage()
    },
    abrir_modal(selectInfo) {
      this.showModal = true;
      this.select_inf = selectInfo;
    },
    fechar_modal2() {
      this.showModal = false;
    },
    convertToFullCalendarDate(datetimeLocal) {
      // O formato recebido é "YYYY-MM-DDTHH:MM:SS", então apenas criar o objeto Date
      return new Date(datetimeLocal);
    },
    convertToDateTimeLocal(date) {
      // Converte o objeto Date para o formato "YYYY-MM-DDTHH:MM:SS"
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Adiciona o zero à esquerda se necessário
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);

      // Formata como 'YYYY-MM-DDTHH:MM:SS'
      let hora_tot = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      return hora_tot;
    },
    fechar_modal() {
      let title = this.agenda.titulo;
      let calendarApi = this.select_inf.view.calendar;
      calendarApi.unselect(); // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: this.convertToFullCalendarDate(this.agenda.dt_ini),
          end: this.convertToFullCalendarDate(this.agenda.dt_fin),
          extendedProps: {
            description: this.agenda.desc,
            pacient_id: this.agenda.pacient_id,
            professional_id: this.agenda.professional_id,
            specialty_id: this.agenda.specialty,
            // Adicionando empresa_id em extendedProps
          },
        });
      }
      this.vet_env_back = [];
      this.currentEvents.forEach((e) => {
        let objeto = {
          title: e.title,
          start: this.isCustomDateFormat(e.start)
            ? this.convertToDateTimeLocal(e.start)
            : e.start,
          end: this.isCustomDateFormat(e.end)
            ? this.convertToDateTimeLocal(e.end)
            : e.end,
          desc: e.extendedProps.description,
          pacient_id: e.extendedProps.pacient_id,
          professional_id: e.extendedProps.professional_id,
          specialty_id: e.extendedProps.specialty_id,
        };
        this.vet_env_back.push({ ...objeto });
      });

      if (this.vet_env_back.length > 0) {
        let tam = this.vet_env_back.length;
        this.doPost(this.vet_env_back[tam - 1]);
      }
    },
    isCustomDateFormat(dateString) {
      // Verifica se a string corresponde ao formato: Thu Sep 19 2024 00:00:00 GMT-0300 (Horário Padrão de Brasília)
      const regex =
        /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([A-Za-zÀ-ÿ\s]+\)$/;
      const isMatch = regex.test(dateString);

      return isMatch;
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    async doPost(event) {
      this.showModal = false;
      // Objeto calendario
      let calendar = {};
      // Adicionando os dados do objeto
      calendar.desc = event.desc;
      calendar.empresa_id = this.currentEmpresa.id;
      calendar.end = moment(event.end).format("yyyy-MM-DDTHH:mm");
      calendar.professional_id = event.professional_id;
      calendar.pacient_id = event.pacient_id;
      calendar.start = moment(event.start).format("yyyy-MM-DDTHH:mm");
      calendar.title = event.title;
      calendar.specialty_id = event.specialty_id;

      // Exibe o SweetAlert com loader
      Swal.fire({
        title: "Aguarde...",
        text: "Estamos processando sua solicitação.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        },
      });

      const promisse = http.post(
        "/agenda?empresa_id=" + this.currentEmpresa.id,
        calendar
      );
      return promisse
        .then(() => {
          this.successmsg();
          this.fetchList();
        })
        .catch((error) => {
          Swal.close(); // Fecha o loader
          console.log(error);
          // Tratamento de erro 500
          if (error.response && error.response.status === 406) {
            // Exibe mensagem de erro específica para o código 406
            let timerInterval;
            Swal.fire({
              icon: "error",
              title: "Erro de Preenchimento!",
              text: error.response.data,
              timer: 3000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const timer = Swal.getPopup().querySelector("b");
                timerInterval = setInterval(() => {
                  timer.textContent = `${Swal.getTimerLeft()}`;
                }, 100);
              },
              willClose: () => {
                clearInterval(timerInterval);
              },
            }).then((result) => {
              /* Read more about handling dismissals below */
              if (result.dismiss === Swal.DismissReason.timer) {
                console.log("I was closed by the timer");
                this.showModal = true;
              }
            });
          } else {
            // Tratamento genérico de outros erros
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Houve um erro ao processar sua requisição. Tente novamente.",
            });
          }
        })
        .finally(() => {});
    },
    doDelete(calendar) {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: "Aguarde...",
        text: "Estamos processando sua solicitação.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        },
      });
      calendar.empresa_id = this.currentEmpresa.id;
      const promisse = http.delete(
        `/agenda/${calendar.id}?empresa_id=${this.currentEmpresa.id}`,
        calendar
      );

      return promisse
        .then(() => {
          Swal.close();
          this.fechar_modal_edit();
        })
        .catch((error) => {
          let timerInterval;
          Swal.fire({
            icon: "error",
            title: "Erro ao tentar Excluir!",
            text: error.response.data,
            timer: 3000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const timer = Swal.getPopup().querySelector("b");
              timerInterval = setInterval(() => {
                timer.textContent = `${Swal.getTimerLeft()}`;
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              console.log("I was closed by the timer");
              this.showModal = true;
            }
          });
        });
    },
    delete_obj_modal() {
      let objeto = this.objeto_geral; // clickinfo
      let objeto_delt = {
        id: objeto.event.id,
        title: objeto.event.title,
        start: objeto.event.start,
        end: objeto.event.end,
        empresa_id: objeto.event.extendedProps.empresa_id,
        pacient_id: objeto.event.extendedProps.pacient_id,
        professional_id: objeto.event.extendedProps.professional_id,
        specialty_id: objeto.event.extendedProps.specialty_id,
      };

      Swal.fire({
        title: "Deseja realmente excluir o Agendamento?",
        text: "'" + objeto.event.title + "'",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.close();
          objeto.event.remove();
          this.doDelete({ ...objeto_delt });
        }
      });
    },
    seleciona_paciente2(objeto) {
      let paci = this.pacientes.find((p) => p.id == objeto);
      this.agenda.titulo = paci.nome;
    },
    seleciona_prof2(objeto) {
      let prof = this.profissionais.find((p) => p.id == objeto);
      this.agenda.titulo = this.agenda.titulo + "|" + prof.name;
    },
    update_obj_modal() {
      let objeto = this.objeto_geral;
      this.seleciona_prof2(this.select_prof);
      this.seleciona_paciente2(this.select_paciente);
      let objeto_delt = {
        id: objeto.event.id,
        title: this.agenda.titulo2,
        start: this.agenda.dt_ini,
        end: this.agenda.dt_fin,
        empresa_id: objeto.event.extendedProps.empresa_id,
        desc: this.agenda.desc,
        pacient_id: this.select_paciente,
        professional_id: this.select_prof,
        specialty_id: this.agenda.specialty,
      };
      this.doPut({ ...objeto_delt });
    },
    openResumoRepasseModal() {
      this.showResumoRepasseModal = true
    },
    showAtedimentReport() {
      console.log('Carregar relatório de evoluções do profissional logado');
      
      try
      {
        // Cria um div para montar o componente
        const wrapper = document.createElement("div");
        // Mostra o componente AtendimentosRealizados
        const componentAtendimentosRealizados = new (Vue.extend(AtendimentosRealizados))({
          propsData: {
            listProfessionals: [],
            listPacients: this.pacientes,
            listSpecialties: this.specialtys,
            currentParams: this.params
          }
        }).$mount();
        // Adiciona o componente ao div
        wrapper.appendChild(componentAtendimentosRealizados.$el);

        const result = Swal.fire({
          title: "Relatório - Atendimentos realizados",
          allowOutsideClick: false,
          showLoaderOnConfirm: true,
          confirmButtonText: "Visualizar",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          html: wrapper,
          preConfirm: () => {
            return new Promise((resolve) => {
              this.atendimentoController.gerarRelatorioAtendimentosProfessional(this.params).then(() => {
                console.log('Entrou no método correto');
                resolve();
              });
            });
          },
        });

        if (result.isConfirmed) {
          this.makeToast("success", "Relatório gerado com sucesso!");
        }
      } catch (error) {
        this.makeToast("danger", error.response.data.message);
      }
    },
    hideIntructions() {
      this.toogleIntructions = !this.toogleIntructions;
    },
    /**
     * Show successfull Save Dialog
     */
    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Atendimento gravado!",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    editEvent(clickInfo) {
      const event = this.contextMenu.event
      // pesquisa o evento na lista de calendários por id
      this.currentHandle = clickInfo
      this.objeto_geral = this.listAgendas.find((e) => e.id == event.id)
      this.viewEvent(event)
      
      this.hideContextMenu()
    },
    resetAppointment() {
      const event = this.contextMenu.event
      if (!event || !event.id) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Evento sem agenda associada. Não é possível solicitar reposição.",
        })
        this.hideContextMenu()
        return
      }
      const agenda = this.listAgendas.find((e) => e.id == event.id) || {}
      const datePart = this.extractEventDatePart(event)
      const startHm = this.timeToHmLiteral(agenda.start_time || event.extendedProps?.startTime)
      let originalEndTime = this.timeToHmLiteral(agenda.end_time || event.extendedProps?.endTime)
      if (!originalEndTime || originalEndTime === '00:00') {
        const rec = this.resolveEventRecurrence(event, agenda)
        if (rec && rec.end_time) {
          originalEndTime = this.timeToHmLiteral(rec.end_time)
        }
      }
      if (!originalEndTime || originalEndTime === '00:00') {
        originalEndTime = moment(`${datePart}T${this.normalizeTimeToSeconds(agenda.start_time || event.extendedProps?.startTime)}`, 'YYYY-MM-DDTHH:mm:ss', true)
          .add(1, 'hour')
          .format('HH:mm')
      }
      this.replacementForm = {
        agenda_id: event.id,
        original_date: datePart,
        original_start_time: startHm,
        original_end_time: originalEndTime,
        new_date: null,
        new_time_start: null,
        new_time_end: null,
      }
      this.showReplacementModal = true
      this.hideContextMenu()
      this.$nextTick(() => {
        this.$bvModal.show("modal-replacement")
      })
    },
    closeReplacementModal() {
      this.showReplacementModal = false
      this.replacementForm = {
        agenda_id: null,
        original_date: null,
        original_start_time: null,
        original_end_time: null,
        new_date: null,
        new_time_start: null,
        new_time_end: null,
      }
      this.$bvModal.hide("modal-replacement")
    },
    submitReplacement() {
      if (!this.replacementForm.new_date || !this.replacementForm.new_time_start || !this.replacementForm.new_time_end) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Preencha a data e os horários de início e fim para a reposição.",
        })
        return
      }
      Swal.fire({
        title: "Aguarde...",
        text: "Criando solicitação de reposição.",
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading() },
      })
      http
        .post("/atendimento/replacement-request", {
          empresa_id: this.currentEmpresa.id,
          agenda_id: this.replacementForm.agenda_id,
          original_date: this.replacementForm.original_date,
          original_start_time: this.replacementForm.original_start_time,
          original_end_time: this.replacementForm.original_end_time,
          new_date: this.replacementForm.new_date,
          new_time_start: this.replacementForm.new_time_start,
          new_time_end: this.replacementForm.new_time_end,
        })
        .then(() => {
          Swal.close()
          Swal.fire({
            icon: "success",
            title: "Solicitação enviada!",
            text: "Sua solicitação de reposição foi criada e aguarda autorização da recepção. Você será notificado quando for autorizada.",
            timer: 3500,
            timerProgressBar: true,
          })
          this.closeReplacementModal()
          this.fetchList()
        })
        .catch((err) => {
          Swal.close()
          const msg = err.response?.data?.error || err.response?.data?.message || "Erro ao criar solicitação de reposição."
          Swal.fire({ icon: "error", title: "Erro", text: msg })
        })
    },
    openSchedulingRequestModal() {
      const event = this.contextMenu.event;
      
      // Verifica se o evento tem atendimento_id
      const atendimentoId = event.extendedProps?.atendimento_id;
      
      if (!atendimentoId || atendimentoId === 0) {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Este evento não possui um atendimento associado. Não é possível solicitar reagendamento.",
        });
        this.hideContextMenu();
        return;
      }

      // Prepara os dados do evento para o formulário
      this.selectedEventForReschedule = {
        atendimento_id: atendimentoId,
        currentDate: this.extractEventDatePart(event),
      };

      this.showSchedulingRequestModal = true;
      this.hideContextMenu();
      
      // Abre o modal usando o método do Bootstrap Vue
      this.$nextTick(() => {
        this.$bvModal.show('modal-scheduling-request');
      });
    },
    closeSchedulingRequestModal() {
      this.showSchedulingRequestModal = false;
      this.selectedEventForReschedule = null;
      this.$bvModal.hide('modal-scheduling-request');
    },
    async handleSchedulingRequestSubmit(requestData) {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: "Aguarde...",
        text: "Estamos processando sua solicitação de reagendamento.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Faz a requisição para a API usando o controller já centralizado.
      // Isso garante o mesmo base URL/auth utilizado pelos demais fluxos de agenda,
      // evitando chamadas relativas que podem cair no host errado do ambiente.
      try {
        await this.schedulingRequestController.createRequest(requestData)
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Solicitação enviada!",
          text: "Sua solicitação de reagendamento foi enviada com sucesso. Você será notificado quando for processada.",
          timer: 3000,
          timerProgressBar: true,
        });

        this.closeSchedulingRequestModal();
      } catch (error) {
        console.error('Erro ao enviar solicitação:', error);
        Swal.close();

        let errorMessage = "Houve um erro ao processar sua requisição.";

        if (error.response) {
          if (error.response.status === 422) {
            // Erro de validação
            const errors = error.response.data.errors || {};
            const errorMessages = Object.values(errors).flat();
            errorMessage = errorMessages.join('<br>');
          } else if (error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        Swal.fire({
          icon: "error",
          title: "Erro ao enviar solicitação",
          html: errorMessage,
        });
      } finally {
        // A tela precisa refletir o estado real da agenda mesmo quando a API
        // rejeitar a solicitação (por exemplo, por validação ou regra de negócio).
        try {
          await this.fetchList();
        } catch (refreshError) {
          console.error('Erro ao atualizar a agenda após solicitação de reagendamento:', refreshError);
        }
      }
    },
    handleSchedulingRequestError(errorMessage) {
      Swal.fire({
        icon: "warning",
        title: "Validação",
        text: errorMessage,
      });
    },
    deleteRecurrence() {
      const event      = this.contextMenu.event
      this.objeto_geral = this.listAgendas.find((e) => e.id == event.id)
      let eventFormatted = this.objeto_geral
      const datePart = this.extractEventDatePart(event)
      const st = this.normalizeTimeToSeconds(eventFormatted.start_time)
      const et = this.normalizeTimeToSeconds(eventFormatted.end_time)
      eventFormatted.start = `${datePart}T${st}`
      eventFormatted.end = `${datePart}T${et}`
      eventFormatted.extendedProps = event.extendedProps
      const recurrence = this.resolveEventRecurrence(event, eventFormatted)
      
      Swal.fire({
        title: "Deseja realmente excluir esta Evolução?",
        text: "Esta ação não poderá ser desfeita",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          this.calendarController.deleteRecurrence(recurrence).then((response) => {
            this.makeToast("success", response.data.success)
            this.fetchList()
          }).catch((error) => {
            this.makeToast("danger", error.response.data.error || error.response.data)
          })
          .finally(() => {
            Swal.close()
          })
        }
      });
      
      this.hideContextMenu()
    },
    async displayCallPatient(event) {
      const agenda = this.listAgendas.find((e) => e.id == event.id) || {}
      const eventDate = this.extractEventDatePart(event)
      const recurrence = this.resolveEventRecurrence(event, agenda)
      if (recurrence && !recurrence.is_authorized) {
        Swal.fire({
          icon: 'warning',
          title: 'Atendimento não autorizado',
          text: 'A recepção precisa autorizar o atendimento antes de chamar o paciente. Solicite que o paciente seja autorizado na tela "Autorizar atendimentos" (Processos).'
        })
        return
      }

      const room = this.currentUser && this.currentUser.room
        ? this.currentUser.room
        : await this.checkRoom()

      if (!room) {
        return
      }

      Swal.fire({
        title: 'Chamando Paciente...',
        text: 'Deseja chamar o Paciente?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        input: "text",
        inputPlaceholder: "Digite o nome da Sala",
        inputLabel: "Nome da Sala",
        inputValue: room,
        inputAttributes: {
          "aria-label": "Digite o nome da Sala",
          "maxlength": String(ROOM_NAME_MAX_CHARS),
        },
        showLoaderOnConfirm: true,
        preConfirm: (room = this.currentUser.room) => {
          const validationMessage = validateRoomName(room)

          if (validationMessage) {
            Swal.showValidationMessage(validationMessage)
            return false
          }

          const normalizedRoom = normalizeRoomName(room)

          const appointmentLocalIso = `${eventDate}T${this.normalizeTimeToSeconds(agenda.start_time || event.extendedProps?.startTime)}`
          let call = {
            "patient_name": event.extendedProps.pacients.nome,
            "professional_name": event.extendedProps.professional.name,
            "room": normalizedRoom,
            "empresa_id": event.extendedProps.empresa_id,
            "recurrence_id": recurrence ? recurrence.id : null,
            "status": "pending",
            "clinic_timezone": CLINIC_TIMEZONE,
            "appointment_local_iso": appointmentLocalIso,
            "requested_at_clinic_iso": moment.tz(CLINIC_TIMEZONE).format("YYYY-MM-DDTHH:mm:ss"),
          }

          return this.callController.store(call)
            .then((response) => {
              this.makeToast("success", response.data.success)
              return response
            })
            .catch((error) => {
              const message =
                error &&
                error.response &&
                error.response.data &&
                (error.response.data.error || error.response.data.message || error.response.data)
                  ? (error.response.data.error || error.response.data.message || error.response.data)
                  : (error && error.message ? error.message : "Erro ao chamar paciente.")

              Swal.showValidationMessage(message)
              this.makeToast("danger", message)
              return Promise.reject(error)
            })
        }
      })
    },
    /** Só permite registrar evolução se existir recorrência e estiver is_authorized (alinhado ao back-end). */
    isRecurrenceAuthorizedForEvolution(recurrence) {
      return isRecurrenceAuthorized(recurrence)
    },
    evolutionNotAuthorizedMessage() {
      return "Evolução não autorizada. O atendimento precisa ser autorizado na recepção (Processos > Autorizar atendimentos) antes do registro da evolução."
    },
    warnEvolutionNotAuthorized() {
      Swal.fire({
        icon: "warning",
        title: "Evolução não autorizada",
        text: this.evolutionNotAuthorizedMessage(),
      })
    },
    // Abrir evento clicado
    viewEvent(event) {
      let eventFormatted = this.objeto_geral
      const datePart = this.extractEventDatePart(event)
      const startTimeNaive = this.normalizeTimeToSeconds(eventFormatted.start_time)
      const endTimeNaive = this.normalizeTimeToSeconds(eventFormatted.end_time)
      eventFormatted.start = `${datePart}T${startTimeNaive}`
      eventFormatted.end = `${datePart}T${endTimeNaive}`

      eventFormatted.extendedProps = event.extendedProps
      eventFormatted.desc = ""

      const recurrence = this.resolveEventRecurrence(event, eventFormatted)

      eventFormatted.desc = recurrence ? recurrence.desc : ""

      // Mês atual / hoje: referência no fuso da clínica (não no relógio local do SO do profissional).
      const nowClinic = moment.tz(CLINIC_TIMEZONE)
      const eventDateClinic = moment.tz(`${datePart}T12:00:00`, CLINIC_TIMEZONE)
      const isCurrentMonth = eventDateClinic.isSame(nowClinic, 'month')
      const parecerIsTodayOrFuture = !eventDateClinic.clone().startOf('day').isBefore(nowClinic.clone().startOf('day'))

      this.parecerEvent = event
      this.parecerEventFormatted = eventFormatted
      this.parecerRecurrence = recurrence || null
      this.parecerIsCurrentMonth = isCurrentMonth
      this.parecerIsTodayOrFuture = parecerIsTodayOrFuture
      this.parecerValue = recurrence && recurrence.desc ? recurrence.desc : ""
      this.showParecerModal = true
    },
    cancelParecerModal() {
      this.showParecerModal = false
    },
    chamarPacienteParecer() {
      if (!this.parecerEvolutionAuthorized) {
        this.warnEvolutionNotAuthorized()
        return
      }

      const event = this.parecerEvent
      this.showParecerModal = false
      if (event) this.displayCallPatient(event)
    },

    /**
     * Marca a recorrência como "ciente" pelo profissional.
     * Endpoint já utilizado em outras telas via Pusher/topbar.
     */
    async markParecerProfessionalAware() {
      if (this.isProcessing || this.isRecording) return
      if (!this.parecerRecurrence || !this.parecerRecurrence.id) return
      if (!this.parecerEvolutionAuthorized) {
        this.warnEvolutionNotAuthorized()
        return
      }
      if (this.parecerProfessionalAware) return

      try {
        this.isProcessing = true
        await http.put(
          `/atendimento/recurrence/${this.parecerRecurrence.id}/professional-aware`,
          null,
          { params: { empresa_id: this.currentEmpresa && this.currentEmpresa.id } }
        )

        // Atualiza o estado local para refletir imediatamente no botão/badges
        this.$set(this.parecerRecurrence, 'professional_aware', true)

        if (Array.isArray(this.listAgendas)) {
          this.listAgendas.forEach((agenda) => {
            if (!agenda || !Array.isArray(agenda.recurrences)) return
            agenda.recurrences.forEach((rec) => {
              if (rec && Number(rec.id) === Number(this.parecerRecurrence.id)) {
                this.$set(rec, 'professional_aware', true)
              }
            })
          })
        }

        this.makeToast('success', 'Você marcou como ciente do atendimento.')
      } catch (e) {
        const msg =
          e &&
          e.response &&
          e.response.data &&
          (e.response.data.error || e.response.data.message)
            ? e.response.data.error || e.response.data.message
            : (e && e.message ? e.message : 'Erro ao marcar como ciente.')
        Swal.fire({ icon: 'error', title: 'Erro', text: msg })
      } finally {
        this.isProcessing = false
      }
    },
    async saveParecer() {
      if (!this.parecerEvolutionAuthorized) {
        this.warnEvolutionNotAuthorized()
        return
      }
      const parecerHtml = this.parecerValue || ""
      const parecerText = String(parecerHtml).replace(/<[^>]*>/g, "").trim()

      const violationMsg = this.parecerEvolutionDateViolationMessage
      if (violationMsg) {
        this.makeToast("danger", violationMsg)
        return
      }

      if (!parecerText) {
        this.makeToast("danger", "Por favor, preencha o Parecer!")
        return
      }

      if (parecerText.length > this.parecerMaxChars) {
        this.makeToast("danger", `O Parecer excedeu o limite de ${this.parecerMaxChars} caracteres`)
        return
      }

      const agendaIn = {
        id: this.parecerRecurrence && this.parecerRecurrence.agenda_id
          ? this.parecerRecurrence.agenda_id
          : this.parecerEvent.id,
        title: this.parecerEvent.title,
        start: this.parecerEventFormatted.start,
        start_time: this.parecerEventFormatted.start_time,
        end: this.parecerEventFormatted.end,
        end_time: this.parecerEventFormatted.end_time,
        desc: parecerHtml,
        recurrence_id: this.parecerRecurrence ? this.parecerRecurrence.id : null,
        color: parecerHtml ? "#1cbb8c" : "#ff0a36",
        pacient_id: this.parecerEvent.extendedProps.pacients.id,
        professional_id: this.parecerEvent.extendedProps.professional_id,
        specialty_id: this.parecerEvent.extendedProps.specialty_id,
      }

      await this.doPut({ ...agendaIn })
      this.showParecerModal = false
    },

    /**
     * Alterna entre iniciar e parar a gravação de áudio do Parecer.
     */
    async toggleRecording() {
      if (this.isRecording) {
        this.stopRecording()
      } else {
        if (!this.parecerEvolutionAuthorized) {
          this.warnEvolutionNotAuthorized()
          return
        }
        await this.startRecording()
      }
    },

    /**
     * Solicita permissão do microfone e inicia a captura.
     */
    async startRecording() {
      const violationMsg = this.parecerEvolutionDateViolationMessage
      if (violationMsg) {
        this.makeToast("danger", violationMsg)
        return
      }

      if (typeof window === "undefined" || !window.MediaRecorder || !navigator.mediaDevices) {
        Swal.fire(
          "Navegador incompatível",
          "Seu navegador não suporta gravação de áudio. Utilize Chrome, Edge ou Firefox atualizados.",
          "error"
        )
        return
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        const mimeCandidates = [
          "audio/webm;codecs=opus",
          "audio/webm",
          "audio/ogg;codecs=opus",
          "audio/mp4",
        ]
        const selectedMime = mimeCandidates.find((mime) =>
          typeof window.MediaRecorder.isTypeSupported === "function"
            ? window.MediaRecorder.isTypeSupported(mime)
            : true
        ) || ""

        this.mediaRecorder = selectedMime
          ? new window.MediaRecorder(stream, { mimeType: selectedMime })
          : new window.MediaRecorder(stream)
        this.audioChunks = []

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data && event.data.size > 0) {
            this.audioChunks.push(event.data)
          }
        }

        this.mediaRecorder.onstop = () => {
          this.sendAudioToApi()
        }

        // timeslice=1000ms garante chunks periódicos e melhor integridade
        // do arquivo final (evita WebM sem metadados de duração).
        this.mediaRecorder.start(1000)
        this.recordingStartedAt = Date.now()
        this.isRecording = true

        // VU meter: monitora volume do microfone em tempo real.
        this.setupAudioAnalyser(stream)
      } catch (error) {
        console.error("Erro ao iniciar gravação de áudio:", error)
        Swal.fire(
          "Permissão negada",
          "Não foi possível acessar o microfone do seu dispositivo. Verifique as permissões do navegador.",
          "error"
        )
      }
    },

    /**
     * Finaliza a gravação atual e libera o microfone.
     */
    stopRecording() {
      const elapsedMs = this.recordingStartedAt ? Date.now() - this.recordingStartedAt : 0

      if (elapsedMs > 0 && elapsedMs < this.minRecordingMs) {
        this.makeToast(
          "warning",
          `Gravação muito curta (${(elapsedMs / 1000).toFixed(1)}s). Fale por pelo menos ${this.minRecordingMs / 1000}s.`
        )
      }

      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.isProcessing = true

        // Força flush do último chunk antes de parar (garante áudio completo).
        try {
          if (typeof this.mediaRecorder.requestData === "function") {
            this.mediaRecorder.requestData()
          }
        } catch (err) {
          // Ignora: nem todos os navegadores suportam requestData.
        }

        this.mediaRecorder.stop()

        if (this.mediaRecorder.stream && typeof this.mediaRecorder.stream.getTracks === "function") {
          this.mediaRecorder.stream.getTracks().forEach((track) => track.stop())
        }
      }

      this.isRecording = false
      this.recordingStartedAt = null
      this.teardownAudioAnalyser()
    },

    /**
     * Configura o AnalyserNode da Web Audio API para medir o volume
     * do microfone em tempo real e atualizar o VU meter na UI.
     */
    setupAudioAnalyser(stream) {
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext
        if (!AudioCtx) return

        this.audioContext = new AudioCtx()
        const source = this.audioContext.createMediaStreamSource(stream)
        this.audioAnalyser = this.audioContext.createAnalyser()
        this.audioAnalyser.fftSize = 512
        source.connect(this.audioAnalyser)

        const buffer = new Uint8Array(this.audioAnalyser.fftSize)
        this.audioLevel = 0
        this.audioLevelMax = 0

        this.audioAnalyserInterval = setInterval(() => {
          if (!this.audioAnalyser) return
          this.audioAnalyser.getByteTimeDomainData(buffer)
          // RMS do sinal (0..1).
          let sum = 0
          for (let i = 0; i < buffer.length; i++) {
            const v = (buffer[i] - 128) / 128
            sum += v * v
          }
          const rms = Math.sqrt(sum / buffer.length)
          // Converte para escala 0-100% com ganho de visualização.
          const level = Math.min(100, Math.round(rms * 250))
          this.audioLevel = level
          if (level > this.audioLevelMax) {
            this.audioLevelMax = level
          }
        }, 100)
      } catch (err) {
        console.warn("Não foi possível iniciar o analisador de áudio:", err)
      }
    },

    teardownAudioAnalyser() {
      if (this.audioAnalyserInterval) {
        clearInterval(this.audioAnalyserInterval)
        this.audioAnalyserInterval = null
      }
      if (this.audioAnalyser) {
        try { this.audioAnalyser.disconnect() } catch (e) { /* noop */ }
        this.audioAnalyser = null
      }
      if (this.audioContext) {
        try { this.audioContext.close() } catch (e) { /* noop */ }
        this.audioContext = null
      }
    },

    /**
     * Converte o texto retornado pela IA (com quebras de linha) em HTML
     * compatível com o CKEditor usado no Parecer.
     */
    evolutionTextToHtml(rawText) {
      const safe = String(rawText || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")

      const paragraphs = safe
        .split(/\n{2,}/)
        .map((block) => block.trim())
        .filter((block) => block.length > 0)
        .map((block) => `<p>${block.replace(/\n/g, "<br>")}</p>`)

      return paragraphs.length > 0 ? paragraphs.join("") : `<p>${safe.replace(/\n/g, "<br>")}</p>`
    },

    /**
     * Envia o áudio gravado para o back-end, que transcreve via Whisper
     * e gera a evolução clínica com IA. Preenche o CKEditor do Parecer
     * com o resultado.
     */
    async sendAudioToApi() {
      if (!this.isRecurrenceAuthorizedForEvolution(this.parecerRecurrence)) {
        this.isProcessing = false
        this.makeToast("danger", this.evolutionNotAuthorizedMessage())
        return
      }
      if (!this.audioChunks || this.audioChunks.length === 0) {
        this.isProcessing = false
        this.makeToast("warning", "Nenhum áudio foi capturado. Tente novamente.")
        return
      }

      const mimeType =
        (this.mediaRecorder && this.mediaRecorder.mimeType) || "audio/webm"
      const extension = mimeType.includes("ogg")
        ? "ogg"
        : mimeType.includes("mp4")
        ? "m4a"
        : "webm"
      const audioBlob = new Blob(this.audioChunks, { type: mimeType })

      if (audioBlob.size <= 0) {
        this.isProcessing = false
        this.audioChunks = []
        this.makeToast("warning", "Áudio vazio. Tente gravar novamente.")
        return
      }

      const formData = new FormData()
      formData.append("audio", audioBlob, `evolucao.${extension}`)
      formData.append("generate_evolution", "1")
      formData.append("language", "pt")
      if (this.parecerRecurrence && this.parecerRecurrence.id) {
        formData.append("recurrence_id", this.parecerRecurrence.id)
      }

      const empresaId = this.currentEmpresa && this.currentEmpresa.id

      try {
        const { data } = await http.post("/ai/evolution/audio/transcribe", formData, {
          params: empresaId ? { empresa_id: empresaId } : undefined,
          headers: {
            "Content-Type": "multipart/form-data",
            ...(empresaId ? { "X-Empresa-Id": empresaId } : {}),
          },
        })

        const payload = (data && data.data) || {}
        const evolutionText =
          (payload.evolution && String(payload.evolution).trim()) ||
          (payload.transcription && String(payload.transcription).trim()) ||
          ""

        if (!evolutionText) {
          this.makeToast("warning", "A IA não retornou conteúdo. Tente gravar novamente com mais detalhes.")
          return
        }

        this.parecerValue = this.evolutionTextToHtml(evolutionText)

        if (this.parecerTextLength > this.parecerMaxChars) {
          this.makeToast(
            "warning",
            `O texto gerado excedeu ${this.parecerMaxChars} caracteres. Ajuste antes de gravar.`
          )
        } else {
          this.$bvToast.toast("Evolução gerada com sucesso pela IA!", {
            title: "Inteligência Artificial",
            toaster: "b-toaster-bottom-right",
            variant: "success",
            solid: true,
          })
        }
      } catch (error) {
        console.error("Erro ao processar áudio da evolução:", error)
        const apiMessage =
          error &&
          error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.error)
        Swal.fire(
          "Erro ao processar áudio",
          apiMessage || "Não foi possível converter o áudio em evolução. Tente novamente.",
          "error"
        )
      } finally {
        this.isProcessing = false
        this.audioChunks = []
        this.mediaRecorder = null
      }
    },

    async checkRoom() {
      if (!this.currentUser || !this.currentUser.room) {
        const result = await Swal.fire({
          title: 'ATENÇÃO',
          text: 'Digite o nome da sala para acessar o sistema.',
          input: 'text',
          inputPlaceholder: 'Nome da Sala',
          inputLabel: 'Nome da Sala',
          inputAttributes: {
            required: true,
            maxlength: String(ROOM_NAME_MAX_CHARS),
            'aria-label': 'Digite o nome da Sala',
          },
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            cancelButtonText: 'Cancelar',
            preConfirm: async (room) => {
              const validationMessage = validateRoomName(room)

              if (validationMessage) {
                Swal.showValidationMessage(validationMessage)
                return false
              }

              const normalizedRoom = normalizeRoomName(room)
              this.currentUser.room = normalizedRoom
              await localStorage.setItem('user', JSON.stringify(this.currentUser))
              await this.fetchList()
              return normalizedRoom
            }
          })

        if (result && result.isConfirmed && result.value) {
          return String(result.value)
        }

        return null
      } else {
        await this.fetchList()
        return this.currentUser.room
      }
    }
  },
}

</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-button
              v-b-toggle="'collapse-instructions'"
              class="m-1"
              variant="warning"
              >Instruções</b-button
            >
            <b-button
              v-b-toggle="'collapse-filters'"
              class="m-1"
              variant="primary"
              >Filtros</b-button>
              <b-button
                @click="showAtedimentReport(params)"
                type="button"
                class="ml-3"
                variant="info"
              >
                  <i class="fas fa-file-pdf"></i>
                  Relat. Atendimentos
              </b-button>
              <b-button
                @click="openResumoRepasseModal"
                type="button"
                class="ml-2"
                variant="outline-info"
              >
                  <i class="fas fa-file-invoice-dollar"></i>
                  Resumo Repasse
              </b-button>
            <b-collapse id="collapse-instructions" class="mt-1">
              <b-card>
                <div class="demo-app-sidebar-section">
                  <ul>
                    <li>
                      Selecione datas e você será solicitado a criar um novo
                      evento
                    </li>
                    <li>Arraste, solte e redimensione eventos</li>
                    <li>Clique em um evento para excluí-lo</li>
                  </ul>
                </div>
                <div class="demo-app-sidebar-section">
                  <label>
                    <input
                      type="checkbox"
                      :checked="calendarOptions.weekends"
                      @change="handleWeekendsToggle"
                    />
                    Adicionar Finais de Semana
                  </label>
                </div>
              </b-card>
            </b-collapse>

            <b-collapse id="collapse-filters" class="mt-1">
              <b-card>
                <div class="row">
                  <div class="col-md-6">
                    <label for="pacient">Por Pacientes:</label>
                    <Multiselect
                      id="pacient"
                      :options="pacientes"
                      v-model="paciente"
                      :multiple="false"
                      selectLabel="Pressione ENTER para selecionar"
                      deselectLabel="Pressione ENTER para remover"
                      placeholder="Selecione um Paciente"
                      track-by="id"
                      label="nome"
                    >
                    </Multiselect>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-button @click="applyAgendaFiltersAndFetch()" variant="primary"
                      >Filtrar</b-button
                    >
                    <b-button
                      class="ml-2"
                      @click="clearAgendaFilters()"
                      variant="outline-danger"
                    >
                      Limpar filtros
                    </b-button>
                  </div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="abr_div">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                class="demo-app-calendar"
                :options="calendarOptions"
                :locale="'pt-br'"
              >
                <template v-slot:eventContent="arg">
                  <b>{{ formatFcEventContentTime(arg) }}</b>
                  <i>{{ arg.event.title }}</i>
                </template>
              </FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- START Modal Insert-->
    <b-modal
      v-model="showModal"
      id="modal-canlendar-insert"
      size="xl"
      :title="'Cadastro Agenda ->  ' + agenda.titulo"
      hide-footer
      @hidden="fechar_modal2()"
    >
      <input type="text" v-model="agenda.titulo" disabled />
      <div class="row">
        <div class="col-md-6">
          <Label>Paciente</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="agenda.pacient_id"
            @change="seleciona_paciente($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in pacientes"
              :key="index"
              :value="item.id"
            >
              {{ item.nome }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <Label>Profissional</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="agenda.professional_id"
            @change="seleciona_prof($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in profissionais"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <Label>Especialidade:</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="agenda.specialty"
            @change="seleciona_specialty($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in specialtys"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <Label>De:</Label>
          <input
            v-model="agenda.dt_ini"
            type="datetime-local"
            step="1"
            class="form-control"
          />
        </div>
        <div class="col-md-3">
          <Label>Até:</Label>
          <input
            v-model="agenda.dt_fin"
            type="datetime-local"
            step="1"
            class="form-control"
          />
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-md-12">
          <Label>Descrição</Label>
          <textarea
            v-model="agenda.desc"
            class="form-control text-left"
            cols="30"
            rows="5"
          ></textarea>
        </div>
      </div>
      <div class="row d-flex justify-content-center align-items-center mt-4">
        <div class="col-md-12 text-center">
          <button class="btn btn-success" @click.prevent="fechar_modal()">
            Salvar
          </button>
        </div>
      </div>
    </b-modal>
    <!-- END Modal Insert -->

    <!-- START Modal Edit -->
    <b-modal
      v-model="modal_edit_del"
      id="modal-calendar-edit"
      size="xl"
      :title="agenda.titulo"
      hide-footer
      @hidden="fechar_modal_edit()"
    >
      <div class="row mb-4 d-flex justify-content-center align-items-center">
        <div class="col-md-12 text-center">
          <div class="form-check">
            <input
               v-model="vtitle"
              class="form-check-input"
              type="checkbox"
              value="1"
              id="flexCheckDefault"
              @change="alter_title($event)"
            />
            <label class="form-check-label" for="flexCheckDefault">
              Alterar titulo
            </label>
          </div>
        </div>
      </div>
      <div class="row" v-if="input_title_bol">
          <div class="col-md-12">
             <input type="text" class="form-control text-left" v-model="agenda.titulo2">
          </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Label>Paciente</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="select_paciente"
            @change="seleciona_paciente($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in pacientes"
              :key="index"
              :value="item.id"
            >
              {{ item.nome }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <Label>Profissional</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="select_prof"
            @change="seleciona_prof($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in profissionais"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <Label>Especialidade</Label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            v-model="agenda.specialty"
            @change="seleciona_specialty($event)"
          >
            <option value="-1">selecione um valor</option>
            <option
              v-for="(item, index) in specialtys"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <Label>De:</Label>
          <input
            v-model="agenda.dt_ini"
            type="datetime-local"
            class="form-control"
            step="1"
          />
        </div>
        <div class="col-md-3">
          <Label>Até:</Label>
          <input
            v-model="agenda.dt_fin"
            type="datetime-local"
            class="form-control"
            step="1"
          />
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-md-12">
          <Label>Descrição</Label>
          <textarea
            v-model="agenda.desc"
            class="form-control text-left"
            cols="30"
            rows="5"
          ></textarea>
        </div>
      </div>
      <div class="row mt-4 d-flex justify-content-center align-items-center">
        <div class="col-md-6 text-center">
          <button class="btn btn-success" @click.prevent="update_obj_modal()">
            Editar
          </button>
        </div>
        <div class="col-md-6 text-center">
          <button class="btn btn-danger" @click.prevent="delete_obj_modal()">
            Excluir
          </button>
        </div>
      </div>
    </b-modal>
    <!-- END Modal Edit -->

    <!-- START Modal Parecer (Evolução) -->
    <b-modal
      v-model="showParecerModal"
      id="modal-parecer"
      size="xl"
      title="Parecer"
      hide-footer
      @hidden="cancelParecerModal"
    >
      <AgendaEventDetail
        v-if="parecerEventFormatted"
        :event="parecerEventFormatted"
        :recurrence="parecerRecurrence"
      />

      <div class="row mt-3">
        <div class="col-md-12">
          <Label>Parecer</Label>

          <!-- Edição liberada quando a data respeita a política da empresa (mês atual / retroativo). -->
          <template v-if="parecerEvolutionDateAllowed">
            <div
              v-if="!parecerEvolutionAuthorized"
              class="alert alert-warning mt-2"
            >
              Para alterar ou registrar a evolução, o atendimento precisa estar autorizado na recepção
              (Processos — Autorizar atendimentos).
            </div>

            <div class="d-flex align-items-center mb-2 flex-wrap">
              <b-button
                type="button"
                :variant="isRecording ? 'danger' : 'outline-primary'"
                :disabled="isProcessing"
                class="mr-3 mb-2 mb-md-0"
                @click.prevent="toggleRecording"
              >
                <i
                  :class="isRecording ? 'fa fa-stop' : 'fa fa-microphone'"
                  class="mr-1"
                ></i>
                {{ isRecording ? 'Parar gravação' : 'Gravar relato por voz (IA)' }}
              </b-button>

              <b-button
                type="button"
                :variant="parecerEvolutionAuthorized ? 'success' : 'danger'"
                class="mr-3 mb-2 mb-md-0"
                :disabled="isProcessing || isRecording || (parecerProfessionalAware && parecerEvolutionAuthorized)"
                @click.prevent="markParecerProfessionalAware"
              >
                {{
                  parecerProfessionalAware && parecerEvolutionAuthorized
                    ? 'Estou ciente'
                    : parecerEvolutionAuthorized
                      ? 'Ciente do Atendimento'
                      : 'Não autorizado'
                }}
              </b-button>

              <b-badge
                :variant="parecerEvolutionAuthorized ? 'success' : 'danger'"
                class="mr-2 mb-2"
              >
                {{ parecerEvolutionAuthorized ? 'Autorizado' : 'Não autorizado' }}
              </b-badge>
              <b-badge
                :variant="parecerProfessionalAware ? 'success' : 'danger'"
                class="mb-2"
              >
                {{ parecerProfessionalAware ? 'Estou ciente' : 'Não estou ciente' }}
              </b-badge>

              <div v-if="isRecording" class="text-danger d-flex align-items-center mr-3 flex-wrap">
                <span class="mic-recording-dot mr-2"></span>
                <span class="mr-2">Gravando... fale o relato.</span>
                <div class="vu-meter" :title="'Nível do microfone: ' + audioLevel + '%'">
                  <div
                    class="vu-meter-bar"
                    :class="audioLevelClass"
                    :style="{ width: audioLevel + '%' }"
                  ></div>
                </div>
                <small
                  v-if="audioLevelWarning"
                  class="text-warning ml-2 font-weight-bold"
                >
                  {{ audioLevelWarning }}
                </small>
              </div>

              <div v-if="isProcessing" class="text-info d-flex align-items-center">
                <b-spinner small class="mr-2"></b-spinner>
                Processando IA e gerando evolução...
              </div>
            </div>

            <div class="position-relative parecer-ckeditor-wrap">
              <ckeditor
                v-model="parecerValue"
                :editor="editor"
                :config="parecerEditorConfig"
                :disabled="isProcessing || isRecording"
                aria-label="Digite um Parecer"
              ></ckeditor>
              <div
                v-if="!parecerEvolutionAuthorized"
                class="parecer-evolution-auth-blocker"
                role="button"
                tabindex="0"
                title="Clique para ver o motivo"
                @click.prevent="warnEvolutionNotAuthorized"
                @keydown.enter.prevent="warnEvolutionNotAuthorized"
              />
            </div>
            <div class="text-danger mt-2">
              Restam&nbsp;<b>{{ parecerRemaining }}</b>&nbsp;caracteres
            </div>
          </template>

          <!-- Data não permite edição: CKEditor somente leitura (visualizar/copiar) -->
          <template v-else>
            <div class="position-relative parecer-ckeditor-wrap">
              <ckeditor
                v-model="parecerValue"
                :editor="editor"
                :config="readonlyEditorConfig"
                :disabled="true"
                aria-label="Visualizar Parecer (somente leitura)"
              ></ckeditor>
            </div>
          </template>
        </div>
      </div>

      <div class="row mt-4 d-flex justify-content-center align-items-center">
        <div class="col-md-4 text-center">
          <button class="btn btn-danger w-100" @click="cancelParecerModal">
            Cancelar
          </button>
        </div>
        <div v-if="parecerIsCurrentMonth && parecerIsTodayOrFuture" class="col-md-4 text-center">
          <button
            class="btn btn-outline-primary w-100"
            :disabled="!parecerCanCallPatient"
            @click="chamarPacienteParecer"
          >
            Chamar Paciente
          </button>
        </div>
        <div v-if="parecerCanSaveEvolution" class="col-md-4 text-center">
          <button class="btn btn-success w-100" @click.prevent="saveParecer">
            Gravar
          </button>
        </div>
      </div>
    </b-modal>
    <!-- END Modal Parecer -->

    <!-- Menu de Contexto -->
    <div 
      v-show="contextMenu.show" 
      :style="contextMenuStyle"
      class="context-menu"
      @click.stop
    >
      <ul>
        <li @click="resetAppointment">
          <i class="bx ri-calendar-check-line"></i>
          Reposição atendimento
        </li>
        <li @click="openSchedulingRequestModal">
          <i class="bx ri-calendar-schedule-line"></i>
          Solicitar reagendamento
        </li>
        <li @click="editEvent">
          <i class="bx ri-edit-2-line"></i>
          Alterar evolução
        </li>
        <li class="danger" @click="deleteRecurrence">
          <i class="bx ri-eraser-fill"></i>
          Excluir evolução
        </li>
      </ul>
    </div>
    
    <!-- Overlay para fechar o menu -->
    <div 
      v-show="contextMenu.show" 
      class="context-menu-overlay"
      @click="hideContextMenu"
    ></div>

    <!-- Modal Solicitação de Reagendamento -->
    <b-modal
      v-if="showSchedulingRequestModal"
      id="modal-scheduling-request"
      title="Solicitar Reagendamento"
      title-class="font-18"
      size="lg"
      hide-footer
      @hide="closeSchedulingRequestModal"
      no-close-on-backdrop
    >
      <SchedulingRequestForm
        v-if="selectedEventForReschedule"
        :atendimento-id="selectedEventForReschedule.atendimento_id"
        :empresa-id="currentEmpresa.id"
        :current-date="selectedEventForReschedule.currentDate"
        @submit="handleSchedulingRequestSubmit"
        @cancel="closeSchedulingRequestModal"
        @error="handleSchedulingRequestError"
      />
    </b-modal>
    <!-- END Modal Solicitação de Reagendamento -->

    <!-- Modal Reposição de Atendimento -->
    <b-modal
      v-if="showReplacementModal"
      id="modal-replacement"
      title="Reposição de atendimento"
      title-class="font-18"
      size="md"
      hide-footer
      @hide="closeReplacementModal"
      no-close-on-backdrop
    >
      <p class="text-muted mb-3">Informe a nova data e horário para a reposição do atendimento. A solicitação ficará aguardando autorização da recepção.</p>
      <div class="form-group">
        <label for="replacement-new-date">Data <span class="text-danger">*</span></label>
        <input
          id="replacement-new-date"
          v-model="replacementForm.new_date"
          type="date"
          class="form-control"
        />
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="replacement-new-time-start">Hora início <span class="text-danger">*</span></label>
          <input
            id="replacement-new-time-start"
            v-model="replacementForm.new_time_start"
            type="time"
            class="form-control"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="replacement-new-time-end">Hora fim <span class="text-danger">*</span></label>
          <input
            id="replacement-new-time-end"
            v-model="replacementForm.new_time_end"
            type="time"
            class="form-control"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-secondary ml-2" @click="closeReplacementModal">Cancelar</button>
        <button type="button" class="btn btn-primary ml-2" @click="submitReplacement">Gravar</button>
      </div>
    </b-modal>
    <!-- END Modal Reposição de Atendimento -->

    <!-- Modal Resumo Repasse (profissional logado) -->
    <b-modal
      v-model="showResumoRepasseModal"
      title="Resumo Repasse"
      size="lg"
      hide-footer
    >
      <ResumoRepasseMe />
    </b-modal>
  </div>
</template>

<style>
/* Estilo para eventos do calendário */
.fc-event,
.fc-event-dot {
  background-color: #4aa3ff;
  border-color: #FFFFFF;
  color: #000000;
}
.editable-span {
  cursor: pointer;
  border-bottom: 1px dashed #ffffff;
  color: #2490ff;
}
.fc-daygrid-event {
  white-space: normal !important;
  align-items: normal !important;
}
.swal-wide{
    width:850px !important;
}

/* estilo para listagem dos eventos */
.fc-list-item {
  background-color: #f8f9fa !important;
  border-color: #dee2e6 !important;
}

/* Estilo para eventos do calendário */

/* Menu de Contexto */
.context-menu {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  min-width: 150px;
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu li {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  transition: background-color 0.2s;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.context-menu li:last-child {
  border-bottom: none;
}

.context-menu li.danger {
  color: #e74c3c;
}

.context-menu li.danger:hover {
  background-color: #ffeaea;
}

.context-menu i {
  margin-right: 8px;
  width: 16px;
}

.context-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.context-menu li:last-child {
  border-bottom: none;
}

.mic-recording-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dc3545;
  box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  animation: mic-pulse 1.2s infinite;
}

.vu-meter {
  width: 140px;
  height: 10px;
  background: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #ced4da;
  margin-right: 4px;
}

.vu-meter-bar {
  height: 100%;
  transition: width 80ms linear, background-color 200ms;
}

.vu-meter-bar--mute {
  background-color: #dc3545;
}

.vu-meter-bar--low {
  background-color: #f6c23e;
}

.vu-meter-bar--good {
  background-color: #1cbb8c;
}

@keyframes mic-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.parecer-ckeditor-wrap {
  min-height: 220px;
}

.parecer-evolution-auth-blocker {
  position: absolute;
  inset: 0;
  z-index: 4;
  cursor: not-allowed;
  background: transparent;
}
</style>
